"use client"
import CardTitle from "@/components/common/card-title";
import { PostBasePageContent } from "@/components/common/posts/post-base-page-content";


export default function Page() {
    return (
         <div className={"flex flex-col gap-6 pb-6"}>
                    <CardTitle title={"Événements"}
                        backgroundImgSrc={"/images/actualites/evenements/baniere.jpeg"} />
        
                    {/* Events Content */}
                   <PostBasePageContent />
                   {/* <div className={"flex flex-col gap-6 pb-6"}>
                       <CardTitle
                           title={"Événements"}
                           backgroundImgSrc={"/images/actualites/evenements/baniere.jpeg"}
                       />
           
                       <SectionPage sectionType="2xl">
                           <div className="gap-6 my-8 flex flex-col">
           
                               <SectionTitle title="Conférence de presse – 4 octobre 2025, siège de Côte d’Ivoire Tourisme"
                                   skin="rose" />
           
                               <div className="flex flex-col gap-2 text-normal">
                                   <p>
                                       La conférence de presse annonçant la 4ᵉ effet du festival Africa Foto Fair 2025 s’est tenue le 4 octobre 2025 au siège de Côte d’Ivoire Tourisme.
                                   </p>
                                   <p className="font-bold mt-4">
                                       Objectifs de l’événement :
                                   </p>
                                   <ul className="space-y-2 pl-4 text-normal list-disc list-inside">
                                       <li>
                                           <span>Valoriser les talents ivoiriens et africains de la photographie</span>
                                       </li>
                                       <li>
                                           <span>Promouvoir la photographie comme outil d’expression artistique</span>
                                       </li>
                                       <li>
                                           <span>Engager la communauté locale autour d’activités créatives et culturelles</span>
                                       </li>
                                   </ul>
                                   <p className="font-bold mt-4">
                                       À propos du festival :
                                   </p>
                                   <ul className="list-disc list-inside pl-4 text-normal">
                                       <li>
                                           Porté par Mme Aïda MULUNEH, le festival favorise les échanges culturels et offre une plateforme internationale aux photographes africains.
                                       </li>
                                   </ul>
                                   <p className="font-bold mt-4">
                                       Programme et participants :
                                   </p>
                                   <ul className="space-y-2 pl-4 text-normal list-disc list-inside">
                                       <li>
                                           <span>Expositions, conférences, ateliers et rencontres</span>
                                       </li>
                                       <li>
                                           <span>78 photographes issus de 35 pays</span>
                                       </li>
                                       <li>
                                           <span>Plus de 7 000 visiteurs attendus</span>
                                       </li>
                                   </ul>
                                   <p className="font-bold mt-4">
                                       Dates et lieu :
                                   </p>
                                   <ul className="space-y-2 pl-4 text-normal list-disc list-inside">
                                       <li>
                                           <span>Du 12 novembre au 7 décembre 2025</span>
                                       </li>
                                       <li>
                                           <span>Grand-Bassam, Côte d’Ivoire</span>
                                       </li>
                                       <li>
                                           <span>Lancement officiel : Institut français de Grand-Bassam</span>
                                       </li>
                                   </ul>
                               </div>
                               <Tags tags={[
                                   "AfricaFotoFair",
                                   "CôtedIvoireTourisme",
                                   "PhotographieAfricaine",
                                   "GrandBassam",
                                   "CultureCI",
                                   "ArtEtCréation"
                               ]} />
                           </div>
           
                           <div className={'mt-8'}>
                               <ImageGallery images={Array.from({ length: 10 }, (_, index) => ({
                                   src: `/images/actualites/evenements/${index + 1}.jpg`,
                                   alt: `Image ${index + 1}`,
                                   width: 1000,
                                   height: 1000
                               }))} gridClassName={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8"} />
                           </div>
                       </SectionPage>
                   </div> */}
                </div>
    );
}
